import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Title, Meta, DomSanitizer } from '@angular/platform-browser';

import { IStrapiDocument, PageNotFound } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [NgFor],
})
export class PageNotFoundComponent extends PageComponent implements OnInit {
  public override pageData: PageNotFound = <PageNotFound>{};

  private cdr = inject(ChangeDetectorRef);

  constructor(
    protected override readonly titleService: Title,
    protected override readonly metaService: Meta,

    public override readonly strapi: StrapiService,

    private readonly sanitizer: DomSanitizer
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi
      .getDocumentsByType('page-not-found', { populate: '*' })
      .subscribe((data: IStrapiDocument<PageNotFound>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
        this.cdr.markForCheck();
      });
  }

  protected override parsePageData(page: PageNotFound): void {
    super.parsePageData(page);
    this.pageData = page;
  }
}
